import useFolderStore from '@/state/folder-store';
import { matchPath } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import { flatMap } from 'lodash-es';
import { FolderItemType } from '@/service/type/Folder';
import { navList } from '@/pages/Home/components/Catalog';

export const flattenFolderState = (
  folderState: FolderItemType[],
): FolderItemType[] => {
  return flatMap(folderState, (folder) => {
    return [folder, ...flattenFolderState(folder.child_folder)];
  });
};

export const useGetBreadName = () => {
  const folderState = useFolderStore((state) => state.folderState);
  const location = useLocation();
  const { pathname } = location;

  let firstPathName = 'MY CATALOG';
  let lastPathName = '';

  const isFolderPath = matchPath('/folder/:folderId', pathname);
  if (Boolean(isFolderPath) && isFolderPath?.params.folderId) {
    const folderId = Number(isFolderPath?.params.folderId);

    const folderName =
      flattenFolderState(folderState).find(({ id }) => id === folderId)?.name ||
      '';
    firstPathName = 'MY FOLDERS';
    lastPathName = `${folderName}`;
  } else {
    const navItem = navList.find((item) => item.to === pathname);
    lastPathName = navItem ? navItem.name : 'Unknown';
  }

  return { firstPathName, lastPathName };
};
